// Below are built-in components that are available in the app, it's recommended to keep them as is

import { BYOCWrapper, NextjsContentSdkComponent, FEaaSWrapper } from '@sitecore-content-sdk/nextjs';
import { Form } from '@sitecore-content-sdk/nextjs';

// end of built-in components
import * as Title from 'src/components/Title';
import * as StructuredData from 'src/components/StructuredData';
import * as ScrollToTopOnBack from 'src/components/ScrollToTopOnBack';
import * as RowSplitter from 'src/components/RowSplitter';
import * as RichText from 'src/components/RichText';
import * as Promo from 'src/components/Promo';
import * as PartialDesignDynamicPlaceholder from 'src/components/PartialDesignDynamicPlaceholder';
import * as PageContent from 'src/components/PageContent';
import * as Navigation from 'src/components/Navigation';
import * as LinkList from 'src/components/LinkList';
import * as Image from 'src/components/Image';
import * as CustomDomScripts from 'src/components/CustomDomScripts';
import * as ContentBlock from 'src/components/ContentBlock';
import * as Container from 'src/components/Container';
import * as ColumnSplitter from 'src/components/ColumnSplitter';
import * as SkipToMainContentBar from 'src/components/authorable/shared/site-structure/SkipToMainContentBar/SkipToMainContentBar';
import * as SkipNav from 'src/components/authorable/shared/site-structure/SkipNav/SkipNav';
import * as MainLayout from 'src/components/authorable/shared/site-structure/MainLayout/MainLayout';
import * as LinkBannerToCW from 'src/components/authorable/shared/site-structure/LinkBannerToCW/LinkBannerToCW';
import * as SearchOverlay from 'src/components/authorable/shared/site-structure/Header/SearchOverlay';
import * as MinimalHeader from 'src/components/authorable/shared/site-structure/Header/MinimalHeader';
import * as LocationInput from 'src/components/authorable/shared/site-structure/Header/LocationInput';
import * as HeaderMobile from 'src/components/authorable/shared/site-structure/Header/HeaderMobile';
import * as HeaderDesktop from 'src/components/authorable/shared/site-structure/Header/HeaderDesktop';
import * as Header from 'src/components/authorable/shared/site-structure/Header/Header';
import * as SocialMedia from 'src/components/authorable/shared/site-structure/Footer/SocialMedia';
import * as LegalInfo from 'src/components/authorable/shared/site-structure/Footer/LegalInfo';
import * as Footer from 'src/components/authorable/shared/site-structure/Footer/Footer';
import * as Breadcrumb from 'src/components/authorable/shared/site-structure/Breadcrumb/Breadcrumb';
import * as SearchforDoctorsNearYou from 'src/components/authorable/shared/search/SearchforDoctorsNearYou';
import * as ProviderSearch from 'src/components/authorable/shared/search/ProviderSearch';
import * as ProviderCardListingSkeleton from 'src/components/authorable/shared/search/ProviderCardListingSkeleton';
import * as ProviderCardListingContent from 'src/components/authorable/shared/search/ProviderCardListingContent';
import * as ProviderCardListing from 'src/components/authorable/shared/search/ProviderCardListing';
import * as LocationSearch from 'src/components/authorable/shared/search/LocationSearch';
import * as GlobalSearch from 'src/components/authorable/shared/search/GlobalSearch';
import * as BlogSearchHeader from 'src/components/authorable/shared/search/BlogSearchHeader';
import * as BlogSearch from 'src/components/authorable/shared/search/BlogSearch';
import * as BlogFacets from 'src/components/authorable/shared/search/BlogFacets';
import * as AZTeachingSheets from 'src/components/authorable/shared/search/AZTeachingSheets';
import * as AZResults from 'src/components/authorable/shared/search/AZResults';
import * as AZMedProfResources from 'src/components/authorable/shared/search/AZMedProfResources';
import * as AZConditionTreatmentSearch from 'src/components/authorable/shared/search/AZConditionTreatmentSearch';
import * as RatingsAndReviews from 'src/components/authorable/shared/page-specific/RatingsAndReviews';
import * as OpenSchedulingWizard from 'src/components/authorable/shared/page-specific/OpenSchedulingWizard';
import * as LocationListing from 'src/components/authorable/shared/page-specific/LocationListing';
import * as Article from 'src/components/authorable/shared/page-specific/Article';
import * as UserScripts from 'src/components/authorable/shared/other/UserScripts';
import * as TeachingSheetSchema from 'src/components/authorable/shared/other/TeachingSheetSchema';
import * as CustomForm from 'src/components/authorable/shared/other/CustomForm';
import * as CallRailScript from 'src/components/authorable/shared/other/CallRailScript';
import * as ButtonArray from 'src/components/authorable/shared/other/ButtonArray';
import * as AppCatalystWidget from 'src/components/authorable/shared/other/AppCatalystWidget';
import * as Media from 'src/components/authorable/shared/media/Media';
import * as ElearningActivity from 'src/components/authorable/shared/media/ElearningActivity';
import * as NavigationCardList from 'src/components/authorable/shared/lists/NavigationCardList';
import * as NavigationCardItem from 'src/components/authorable/shared/lists/NavigationCardItem';
import * as CarouselItem from 'src/components/authorable/shared/lists/CarouselItem';
import * as Carousel from 'src/components/authorable/shared/lists/Carousel';
import * as AccordionItem from 'src/components/authorable/shared/lists/AccordionItem';
import * as Accordion from 'src/components/authorable/shared/lists/Accordion';
import * as SideNavSection from 'src/components/authorable/shared/layout/SideNavSection';
import * as SideNavContainer from 'src/components/authorable/shared/layout/SideNavContainer';
import * as ParentChildSideNav from 'src/components/authorable/shared/layout/ParentChildSideNav';
import * as CenteredContainer from 'src/components/authorable/shared/layout/CenteredContainer';
import * as TextMedia from 'src/components/authorable/shared/content/TextMedia';
import * as TextList from 'src/components/authorable/shared/content/TextList';
import * as TextLinkList from 'src/components/authorable/shared/content/TextLinkList';
import * as TeachingSheetInfo from 'src/components/authorable/shared/content/TeachingSheetInfo';
import * as Statistics from 'src/components/authorable/shared/content/Statistics';
import * as SpecialtyHeader from 'src/components/authorable/shared/content/SpecialtyHeader';
import * as SocialShare from 'src/components/authorable/shared/content/SocialShare';
import * as RelatedBlogs from 'src/components/authorable/shared/content/RelatedBlogs';
import * as RTE from 'src/components/authorable/shared/content/RTE';
import * as ProviderHeader from 'src/components/authorable/shared/content/ProviderHeader';
import * as OfficeHours from 'src/components/authorable/shared/content/OfficeHours';
import * as Modal from 'src/components/authorable/shared/content/Modal';
import * as LocationHeader from 'src/components/authorable/shared/content/LocationHeader';
import * as InPageBanner from 'src/components/authorable/shared/content/InPageBanner';
import * as HeroHeader from 'src/components/authorable/shared/content/HeroHeader';
import * as Hero from 'src/components/authorable/shared/content/Hero';
import * as GlobalAlert from 'src/components/authorable/shared/content/GlobalAlert';
import * as FormContainer from 'src/components/authorable/shared/content/FormContainer';
import * as FeaturedStories from 'src/components/authorable/shared/content/FeaturedStories';
import * as EventsBanner from 'src/components/authorable/shared/content/EventsBanner';
import * as ContentDrivenAppointmentModal from 'src/components/authorable/shared/content/ContentDrivenAppointmentModal';
import * as ConditionHeader from 'src/components/authorable/shared/content/ConditionHeader';
import * as BlogTags from 'src/components/authorable/shared/content/BlogTags';
import * as BlogResources from 'src/components/authorable/shared/content/BlogResources';
import * as BlogDetailHeader from 'src/components/authorable/shared/content/BlogDetailHeader';
import * as AuthorCard from 'src/components/authorable/shared/content/AuthorCard';
import * as AppointmentModal from 'src/components/authorable/shared/content/AppointmentModal';
import * as Alert from 'src/components/authorable/shared/content/Alert';
import * as GeneralHeaderHeaderJumpLink from 'src/components/authorable/shared/content/GeneralHeader/GeneralHeader.HeaderJumpLink';
import * as GeneralHeader from 'src/components/authorable/shared/content/GeneralHeader/GeneralHeader';

export const componentMap = new Map<string, NextjsContentSdkComponent>([
  ['BYOCWrapper', BYOCWrapper],
  ['FEaaSWrapper', FEaaSWrapper],
  ['Form', Form],
  ['Title', { ...Title }],
  ['StructuredData', { ...StructuredData }],
  ['ScrollToTopOnBack', { ...ScrollToTopOnBack }],
  ['RowSplitter', { ...RowSplitter }],
  ['RichText', { ...RichText }],
  ['Promo', { ...Promo }],
  ['PartialDesignDynamicPlaceholder', { ...PartialDesignDynamicPlaceholder }],
  ['PageContent', { ...PageContent }],
  ['Navigation', { ...Navigation }],
  ['LinkList', { ...LinkList }],
  ['Image', { ...Image }],
  ['CustomDomScripts', { ...CustomDomScripts }],
  ['ContentBlock', { ...ContentBlock }],
  ['Container', { ...Container }],
  ['ColumnSplitter', { ...ColumnSplitter }],
  ['SkipToMainContentBar', { ...SkipToMainContentBar, componentType: 'client' }],
  ['SkipNav', { ...SkipNav }],
  ['MainLayout', { ...MainLayout }],
  ['LinkBannerToCW', { ...LinkBannerToCW, componentType: 'client' }],
  ['SearchOverlay', { ...SearchOverlay }],
  ['MinimalHeader', { ...MinimalHeader }],
  ['LocationInput', { ...LocationInput }],
  ['HeaderMobile', { ...HeaderMobile }],
  ['HeaderDesktop', { ...HeaderDesktop }],
  ['Header', { ...Header }],
  ['SocialMedia', { ...SocialMedia }],
  ['LegalInfo', { ...LegalInfo }],
  ['Footer', { ...Footer }],
  ['Breadcrumb', { ...Breadcrumb }],
  ['SearchforDoctorsNearYou', { ...SearchforDoctorsNearYou }],
  ['ProviderSearch', { ...ProviderSearch }],
  ['ProviderCardListingSkeleton', { ...ProviderCardListingSkeleton }],
  ['ProviderCardListingContent', { ...ProviderCardListingContent }],
  ['ProviderCardListing', { ...ProviderCardListing }],
  ['LocationSearch', { ...LocationSearch, componentType: 'client' }],
  ['GlobalSearch', { ...GlobalSearch }],
  ['BlogSearchHeader', { ...BlogSearchHeader }],
  ['BlogSearch', { ...BlogSearch }],
  ['BlogFacets', { ...BlogFacets }],
  ['AZTeachingSheets', { ...AZTeachingSheets }],
  ['AZResults', { ...AZResults }],
  ['AZMedProfResources', { ...AZMedProfResources }],
  ['AZConditionTreatmentSearch', { ...AZConditionTreatmentSearch }],
  ['RatingsAndReviews', { ...RatingsAndReviews }],
  ['OpenSchedulingWizard', { ...OpenSchedulingWizard }],
  ['LocationListing', { ...LocationListing }],
  ['Article', { ...Article }],
  ['UserScripts', { ...UserScripts }],
  ['TeachingSheetSchema', { ...TeachingSheetSchema }],
  ['CustomForm', { ...CustomForm }],
  ['CallRailScript', { ...CallRailScript }],
  ['ButtonArray', { ...ButtonArray, componentType: 'client' }],
  ['AppCatalystWidget', { ...AppCatalystWidget }],
  ['Media', { ...Media }],
  ['ElearningActivity', { ...ElearningActivity }],
  ['NavigationCardList', { ...NavigationCardList, componentType: 'client' }],
  ['NavigationCardItem', { ...NavigationCardItem, componentType: 'client' }],
  ['CarouselItem', { ...CarouselItem }],
  ['Carousel', { ...Carousel }],
  ['AccordionItem', { ...AccordionItem }],
  ['Accordion', { ...Accordion }],
  ['SideNavSection', { ...SideNavSection }],
  ['SideNavContainer', { ...SideNavContainer }],
  ['ParentChildSideNav', { ...ParentChildSideNav }],
  ['CenteredContainer', { ...CenteredContainer }],
  ['TextMedia', { ...TextMedia, componentType: 'client' }],
  ['TextList', { ...TextList }],
  ['TextLinkList', { ...TextLinkList }],
  ['TeachingSheetInfo', { ...TeachingSheetInfo }],
  ['Statistics', { ...Statistics }],
  ['SpecialtyHeader', { ...SpecialtyHeader }],
  ['SocialShare', { ...SocialShare }],
  ['RelatedBlogs', { ...RelatedBlogs }],
  ['RTE', { ...RTE }],
  ['ProviderHeader', { ...ProviderHeader }],
  ['OfficeHours', { ...OfficeHours }],
  ['Modal', { ...Modal }],
  ['LocationHeader', { ...LocationHeader }],
  ['InPageBanner', { ...InPageBanner }],
  ['HeroHeader', { ...HeroHeader }],
  ['Hero', { ...Hero }],
  ['GlobalAlert', { ...GlobalAlert, componentType: 'client' }],
  ['FormContainer', { ...FormContainer, componentType: 'client' }],
  ['FeaturedStories', { ...FeaturedStories, componentType: 'client' }],
  ['EventsBanner', { ...EventsBanner }],
  ['ContentDrivenAppointmentModal', { ...ContentDrivenAppointmentModal }],
  ['ConditionHeader', { ...ConditionHeader }],
  ['BlogTags', { ...BlogTags }],
  ['BlogResources', { ...BlogResources }],
  ['BlogDetailHeader', { ...BlogDetailHeader }],
  ['AuthorCard', { ...AuthorCard }],
  ['AppointmentModal', { ...AppointmentModal }],
  ['Alert', { ...Alert, componentType: 'client' }],
  ['GeneralHeader', { ...GeneralHeaderHeaderJumpLink, ...GeneralHeader }],
]);

export default componentMap;
